/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import {
  TableRow, TableCell, TableHead, TableSortLabel, Checkbox,
} from '@material-ui/core';
import { tableHeaderStyles } from '../tableStyles';

export default function UserListHead({
  // eslint-disable-next-line no-unused-vars
  rowCount,
  headLabel,
  // NEW: Selection props
  enableSelection = false,
  isAllSelected = false,
  onSelectAll,
}) {
  const classes = tableHeaderStyles();
  return (
    <TableHead className={classes.header}>
      <TableRow>
        {/* NEW: Selection checkbox column */}
        {enableSelection && (
          <TableCell className={classes.headerTitle} padding="checkbox">
            <Checkbox
              checked={isAllSelected}
              onChange={onSelectAll}
              color="primary"
            />
          </TableCell>
        )}
        {headLabel.map((headCell) => {
          if (headCell.id === 'actions') {
            const {
              read, edit, remove, add, revoke,
            } = headCell.flag || {};
            if (!read && !edit && !remove && !add && !revoke) return <></>;

            return (
              <TableCell
                className={classes.headerTitle}
                key={headCell.id}
                align={headCell.alignRight ? 'right' : 'left'}
              >
                <TableSortLabel
                  hideSortIcon
                >
                  {headCell.label}
                </TableSortLabel>
              </TableCell>
            );
          }
          if (headCell.flag === 'viewCollectiblepaymentMethod') {
            return (
              <TableCell
                className={classes.headerTitle}
                key={headCell.id}
                align="center"
              >
                <TableSortLabel
                  hideSortIcon
                >
                  {headCell.label}
                </TableSortLabel>
              </TableCell>
            );
          }
          return (
            <TableCell
              className={classes.headerTitle}
              key={headCell.id}
              align={headCell.alignRight ? 'right' : 'left'}
            >
              <TableSortLabel
                hideSortIcon
              >
                {headCell.label}
              </TableSortLabel>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}

UserListHead.propTypes = {
  rowCount: PropTypes.number,
  headLabel: PropTypes.array,
  // NEW: Selection props
  enableSelection: PropTypes.bool,
  isAllSelected: PropTypes.bool,
  isPartiallySelected: PropTypes.bool,
  onSelectAll: PropTypes.func,
};
